import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import { Logo } from '../../components/images';

const MainHeader = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-sm border-b sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/main-signup" className="flex items-center flex-shrink-0">
            <img src={Logo} className="w-8 h-8 mr-2" alt="Logo"/>
            <span className="text-lg sm:text-xl font-medium text-gray-800">
              Oodles Internships
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6">
            <Link 
              to="/about" 
              className="text-gray-600 hover:text-orange-500 transition-colors"
            >
              About
            </Link>
            <Link 
              to="/faq" 
              className="text-gray-600 hover:text-orange-500 transition-colors"
            >
              FAQs
            </Link>
            <Link 
              to="/main-signup" 
              className="bg-orange-500 text-white px-4 py-2 rounded-lg hover:bg-orange-600 transition-colors"
            >
              Sign Up Now!
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMobileMenu}
            className="md:hidden p-2 rounded-lg text-gray-600 hover:text-orange-500 hover:bg-gray-100 transition-colors"
            aria-label="Toggle mobile menu"
          >
            {isMobileMenuOpen ? (
              <FaTimes className="w-6 h-6" />
            ) : (
              <FaBars className="w-6 h-6" />
            )}
          </button>
        </div>

        {/* Mobile Navigation Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden absolute top-full left-0 right-0 bg-white border-t border-gray-200 shadow-lg z-50">
            <nav className="px-4 py-4 space-y-4">
              <Link 
                to="/about" 
                onClick={closeMobileMenu}
                className="block text-gray-600 py-2 hover:text-orange-500 transition-colors"
              >
                About
              </Link>
              <Link 
                to="/faq" 
                onClick={closeMobileMenu}
                className="block text-gray-600 py-2 hover:text-orange-500 transition-colors"
              >
                FAQs
              </Link>
              <Link 
                to="/main-signup" 
                onClick={closeMobileMenu}
                className="block bg-orange-500 text-white px-4 py-3 rounded-lg hover:bg-orange-600 transition-colors text-center font-medium"
              >
                Sign Up Now!
              </Link>
            </nav>
          </div>
        )}
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="md:hidden fixed inset-0 bg-black bg-opacity-25 z-40"
          onClick={closeMobileMenu}
        />
      )}
    </header>
  );
};

export default MainHeader;